import { Typography, NewDropdown } from 'app/components/ui';
import { Modal as BootstrapModal } from 'react-bootstrap';
import { useState } from 'react';
import { IconButton } from 'app/components/ui/IconButton/IconButton';
import { i18n } from 'app/utils/i18n';

import './HighlightedPicker.scss';

interface HighlightedProps {
  currentValue: string;
  onValueChange: (value: string) => void;
}

export const HighlightedPicker = ({ currentValue, onValueChange }: HighlightedProps) => {
  const [show, setShow] = useState(false);
  const highlightedOptions = [
    {
      label: i18n('tag.highlighted.option.tagger'),
      value: 'tagger',
    },
    {
      label: i18n('tag.highlighted.option.status'),
      value: 'status',
    },
    { label: i18n('tag.highlighted.option.origin'), value: 'origin' },
    { label: i18n('tag.highlighted.option.process'), value: 'process' },
  ];

  const contextColors = [
    {
      category: i18n('tag.highlighted.option.status'),
      colors: [
        { label: i18n('tag.status.invalid'), value: 'invalid' },
        { label: i18n('tag.status.valid'), value: 'valid' },
        { label: i18n('tag.status.unvalidated'), value: 'unvalidated' },
      ],
    },
    {
      category: i18n('tag.highlighted.option.process'),
      colors: [
        { label: i18n('tag.status.draft'), value: 'draft' },
        { label: i18n('tag.status.need_attention'), value: 'need_attention' },
        { label: i18n('tag.status.verified'), value: 'verified' },
        { label: i18n('tag.status.approved'), value: 'approved' },
      ],
    },
    {
      category: i18n('tag.highlighted.option.tagger'),
      colors: [
        { label: i18n('tag.highlighted.ai'), value: 'human' },
        { label: i18n('tag.highlighted.human'), value: 'ai' },
      ],
    },
    {
      category: i18n('tag.highlighted.option.origin'),
      colors: [
        { label: i18n('tag.highlighted.core'), value: 'core' },
        { label: i18n('tag.highlighted.extension'), value: 'extension' },
      ],
    },
  ];

  return (
    <>
      <NewDropdown
        currentValue={currentValue}
        label={`${i18n('tag.highlighted.label')}:`}
        options={highlightedOptions}
        onUpdate={onValueChange}
        showSelectBox
        customOption={
          <div onClick={() => setShow(true)} style={{ width: '100%' }}>
            <Typography variant="body-5" fontWeight="bold">
              {i18n('tag.color.guide.action')}
            </Typography>
          </div>
        }
      />

      <BootstrapModal show={show} onHide={() => setShow(false)} contentClassName="highlighted-modal">
        <BootstrapModal.Header className="highlighted-modal__header">
          <Typography variant="body-8" fontWeight="semibold">
            {i18n('tag.color.guide.label')}
          </Typography>

          <IconButton variant="transparent" icon="close" onClick={() => setShow(false)} data-bs-dismiss="modal" aria-label="Close" />
        </BootstrapModal.Header>

        <BootstrapModal.Body className="highlighted-modal__body">
          {contextColors.map((context) => (
            <ul key={context.category} className="highlighted-modal__context-section">
              <Typography variant="body-7" fontWeight="semibold" color="#616066">
                {context.category}
              </Typography>

              {context.colors.map((color) => (
                <li key={color.label} className="highlighted-modal__context-item">
                  <div className={`highlighted-modal__context-color highlighted-modal__context-color--${color.value}`} />
                  <Typography variant="body-7" fontWeight="light" color="#616066">
                    {color.label}
                  </Typography>
                </li>
              ))}
            </ul>
          ))}
        </BootstrapModal.Body>
      </BootstrapModal>
    </>
  );
};
